import React from 'react';
import appConfig from '../../app-config';

import './footer.scss';

export default class Footer extends React.Component {
  render() {
    return (
      <div className='footer'>
        <div className="container">
          <div className="row">
            <div>
              <p className="copyright-info">
                <a className="copyright-link" href="http://fredericpaladin.com" target="blank" rel="noreferrer">Frederic Paladin</a>
                <span> | </span>Copyright © {(new Date()).getFullYear()}
                <br />
              </p>
              <p className='footer-version'>version {appConfig.app.version}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}